<div class="error-box">
  <div class="error-title">{{ title }}</div>
  <div class="vertical-spacing-12"></div>
  <div class="error-description">{{ description }}</div>
  <div class="vertical-spacing-12"></div>
  <div class="error-btn yellow-button" (click)="close()">
    {{ 'checkOut.continue' | translate }}
  </div>
</div>